import requests from "./requests";
export default {
  namespaced: true,
  modules: {
    requests,
  },
};
